// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Suppliers_pageLayout__3B1b9"};